import './css/app.css';
import 'vendor/lazysizes';

import { App } from '@grafikr/components';

import components from 'framework/components';
import state from 'framework/state';

import initGift from './js/components/rebuy-smart-cart';
import removeEmptySections from './js/framework/remove-empty-sections';
import referrer from './js/framework/tracking/referrer';
import utmParameters from './js/framework/tracking/utm-parameters';

const app = new App();

components(app);
state(app);
app.mount();

referrer();
utmParameters();
removeEmptySections();

document.addEventListener('shopify:section:load', () => app.mount());
document.addEventListener('rebuy:smartcart.ready', initGift);
document.addEventListener('rebuy:cart.change', initGift);
